import { useLatest } from 'ahooks'

import { IS_DEV } from '@/helpers/env'

export function useCookieDomain() {
  const hostKey = useHostKey()
  const url = useUrl()

  const cookieDomain = IS_DEV
    ? `${url.hostname.replace('dev', '')}`
    : `.${hostKey}`

  const cookieDomainRef = useLatest(cookieDomain)
  return {
    cookieDomain,
    cookieDomainRef,
  }
}
